import { FirebaseAuthActionHandler } from '@dai/firebase-auth'
import { useSearchParams } from 'react-router-dom'

import useAuth from '@/hooks/useAuth'
import useT from '@/i18n/useT'

function AuthActionHandler() {
  const auth = useAuth()
  const [searchParams] = useSearchParams()
  const mode = searchParams.get('mode')
  const oobCode = searchParams.get('oobCode')
  const { t } = useT()

  return (
    <FirebaseAuthActionHandler
      {...auth}
      mode={mode}
      oobCode={oobCode}
      signInUrl={'/auth/sign-in'}
      signUpUrl={'/auth/sign-up'}
      labels={{
        passwordReset: {
          title: t('auth.resetPassword.title'),
          subtitle: t('auth.resetPassword.subtitle'),
          mustBeValidEmail: t('auth.resetPassword.validation.invalidEmail'),
          emailRequired: t('auth.resetPassword.validation.emailRequired'),
          email: t('login.emailAddress'),
          resetPasswordButton: t('auth.resetPassword.resetPasswordButton'),
          emailSentConfirmationMessage: (email: string) =>
            t('auth.resetPassword.emailSentConfirmationMessage', {
              email,
            }),
          defaultErrorMessage: t('auth.resetPassword.defaultErrorMessage'),
          signUpButton: t('login.signUp'),
          dontHaveAnAccount: t('login.noAccountYet.message'),
        },
      }}
    />
  )
}

export default AuthActionHandler
